// A line-clamped element keeps its full text in the scroll box, so an overflow
// of more than a rounding pixel means lines are hidden.
export function isTextClamped(el: HTMLElement | null | undefined): boolean {
	if (!el) return false
	return el.scrollHeight - el.clientHeight > 1
}
